import { Box } from "@mui/material";
import SecurityClassManager from "./SecurityClassManager";

const Classes = ({ exparience, setExparience, isAdmin }) => {
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <SecurityClassManager
        exparience={exparience}
        setExparience={setExparience}
        isAdmin={isAdmin}
      />
    </Box>
  );
};

export default Classes;
